var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Spacer',{class:[
    'sidebar-footer',
    _vm.layout && _vm.layout !== '' ? ("sidebar-footer--" + _vm.layout) : null ],attrs:{"all":"m"}},[_c('Icon',{attrs:{"fn":_vm.togglePopUp,"name":"account"}}),_c('Icon',{attrs:{"to":{ name: 'Search' },"name":"search"}}),_c('transition',{attrs:{"name":"fade"}},[(_vm.popUpIsVisible)?_c('PopUp',{on:{"hide-pop-up":_vm.togglePopUp}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }